import { Checkbox } from "primereact/checkbox";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const DragRow = ({ row, rowIndex, isSelected, onToggleSelect, renderBody }) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: row.city }); // уникальный id

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.3 : 1,
        zIndex: isDragging ? 1000 : "auto",
    };

    return (
        <div ref={setNodeRef} style={style} className={`table-row ${isDragging ? "dragging" : ""}`}>
            <div className="table-cell checkbox-cell">
                <div {...attributes} {...listeners}>
                    <i className="pi pi-arrows-v" style={{ color: "#000000", cursor: "grab", marginRight: "6px" }} />
                </div>
                <Checkbox onChange={(e) => onToggleSelect(e.checked)} checked={isSelected}></Checkbox>
            </div>
            <div className="table-cell city-cell">
                <span>{row.city}</span>
            </div>

            <div className="table-cell addresses-cell">{renderBody(row, { rowIndex })}</div>
        </div>
    );
};

export default DragRow;
